export default __webpack_public_path__ + "static/media/old.8d7b64e6.png";